import React, { FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { EuiPageHeader, EuiPageHeaderSection, EuiTitle, EuiFlexGroup, EuiFlexItem, EuiButtonIcon, EuiIcon, EuiSwitch, EuiButtonEmpty, EuiText } from '@elastic/eui'
import { EuiSwitchEvent } from '@elastic/eui/src/components/form/switch/switch'

import { selectEditMode, setEditMode } from '../masterCampaignPlanSlice'

export interface MasterCampaignPlanHeaderProps {
  planName: string
  accountName?: string
  showAgencyInfo?: boolean
  onEditNameClick?: () => void
}

const MasterCampaignPlanHeader: FC<MasterCampaignPlanHeaderProps> = props => {
  const dispatch = useDispatch()
  const editMode = useSelector(selectEditMode)

  const handleEditModeChange = (e: EuiSwitchEvent) => {
    dispatch(setEditMode(e.target.checked))
  }

  return (
    <EuiPageHeader>
      <EuiPageHeaderSection style={{ width: '100%' }}>
        <EuiFlexGroup direction='column' gutterSize='m'>
          <EuiFlexItem grow={false}>
            <EuiTitle size='m'>
              <h1>Master Campaign Plan: {props.accountName}</h1>
            </EuiTitle>
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false}>
              <EuiFlexItem grow={false}>
                <EuiTitle size='s'>
                  <h2>{props.planName}</h2>
                </EuiTitle>
              </EuiFlexItem>
              {editMode && (
                <EuiFlexItem grow={false}>
                  <EuiButtonIcon iconType='pencil' onClick={() => props.onEditNameClick?.()} aria-label='Edit Name' />
                </EuiFlexItem>
              )}
              <EuiFlexItem />

              <EuiFlexItem grow={false}>
                <EuiFlexGroup gutterSize='s' alignItems={'center'}>
                  <EuiFlexItem grow={true}>
                    <EuiText size='s'>Edit Mode</EuiText>
                  </EuiFlexItem>
                  <EuiFlexItem grow={false}>
                    <EuiSwitch label='Edit Mode' showLabel={false} checked={editMode} onChange={handleEditModeChange} />
                  </EuiFlexItem>
                </EuiFlexGroup>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiPageHeaderSection>
    </EuiPageHeader>
  )
}

export default MasterCampaignPlanHeader
